export const si = {
    //සංචාලන තීරුව
    'n1': 'මුල් පිටුව',
    'n2': 'ඇණවුම්',
    'n3': 'ගනුදෙනු',
    'n4': 'කණ්ඩායම',
    'n5': 'මගේ',
    //ඉඟි
    't1': 'දෝෂයක් ඇතිවිය',
    't2': 'පිටපත් කිරීම සාර්ථකයි',
    't3': 'කරුණාකර සියලු තොරතුරු සම්පූර්ණ කරන්න',
    't4': 'පූරණය වෙමින්...',
    't5': 'පිවිසීම සාර්ථකයි',
    't6': 'ඉදිරිපත් කිරීමට ශ්‍රේණිගත කිරීම 3ට වඩා වැඩි විය යුතුය',
    't7': 'ඉදිරිපත් කිරීම සාර්ථකයි',
    't8': 'ශේෂය ප්‍රමාණවත් නොවේ, ලබා ගත නොහැක',
    't9': 'ඉදිරිපත් කිරීම අසාර්ථකයි',
    't10': 'කරුණාකර පළමුව මුදල් ආපසු ගැනීමේ ලිපිනය බැඳින්න',
    't11': 'ලිපිනය දැනටමත් බැඳී ඇත, කරුණාකර පාරිභෝගික සේවය අමතන්න',
    't12': 'වෙනස් කිරීම සාර්ථකයි',
    't13': 'වෙනස් කිරීම අසාර්ථකයි',
    't14': 'මුරපදය වෙනස් කිරීමට කරුණාකර පාරිභෝගික සේවය අමතන්න',
    't15': 'මුරපද ආකෘතිය වැරදියි',
    't16': 'මුදල් ආපසු ගැනීම සාර්ථකයි',
    't17': 'උපරිම මුදල් ආපසු ගැනීම',
    't18': 'අවම මුදල් ආපසු ගැනීම',
    't19': 'මුරපද දෙක නොගැලපේ',
    't20': 'දැනුම්දීම',
    't21': 'තාවකාලිකව පිවිසිය නොහැක',
    't22': 'මුරපද ආකෘතිය වැරදියි',
    't23': 'ලියාපදිංචිය සාර්ථකයි',
    't24': 'කරුණාකර ප්‍රාදේශීය කේතය ඇතුළත් කරන්න',
    't25': 'තවත් නැත',
    //පිවිසීම / ලියාපදිංචිය
    'l1': 'භාෂාව',
    'l2': 'කරුණාකර ගිණුම ඇතුළත් කරන්න',
    'l3': 'කරුණාකර මුරපදය ඇතුළත් කරන්න',
    'l4': 'මතක තබා ගන්න',
    'l5': 'පිවිසෙන්න',
    'l6': 'ලියාපදිංචි වෙන්න',
    'l7': 'ගිණුමක් නැත',
    'l8': 'දුරකථන අංකය',
    'l9': 'අන්වර්ථ නාමය',
    'l10': 'මුරපදය',
    'l11': 'මුරපදය තහවුරු කරන්න',
    'l12': 'ආරාධනා කේතය',
    'l13': 'ලියාපදිංචි වෙන්න',
    'l14': 'දැනටමත් ගිණුමක් ඇත',
    'l15': 'පිවිසෙන්න',
    'l16': 'කරුණාකර ඉලක්කම් 6-16 මුරපදයක් ඇතුළත් කරන්න',

    //උදව්
    'bz1': 'උදව්',
    'bz2': 'නිතර අසන ප්‍රශ්න',
    'bz3': 'ගනුදෙනු රීති',
    'bz4': 'මුදල් ආපසු ගන්නේ කෙසේද',
    'bz5': 'මුදල් එකතු කරන්නේ කෙසේද',
    'bz6': '1.ebay Review RoBoT යනු කුමක්ද?',
    'bz7': 'ebay Review RoBoT යනු ලොව පුරා සිටින ebay Review RoBoT සබැඳි වෙළඳසැල් වෙළෙන්දන්ට වැඩි ඇණවුම් විකුණුම් ලබා ගැනීමට සහ ebay Review RoBoT සබැඳි වෙළඳසැල්වල බ්‍රවුසින් දත්ත වැඩි කිරීමට උපකාර වන අලෙවිකරණ ප්‍රවර්ධන සමාගමකි. අපි ebay Review RoBoT, වෙළෙන්දන් සහ පාරිභෝගිකයන් අතර ත්‍රෛපාර්ශ්වික ලාභදායී අලෙවිකරණ ප්‍රවර්ධන ආකෘතියක් පිහිටුවීමට කැපවී සිටිමු. නවතම P2P බ්ලොක්චේන් තාක්ෂණය සමඟ ඒකාබද්ධව, USDT (TRC20, ERC20) හරහා පාරිභෝගිකයන් සහ වෙළෙන්දන් ඉක්මනින් සම්බන්ධ කරන්න. ලියාපදිංචි පරිශීලකයන්ට ඇණවුම් වලින් කොමිස් ලබා ගත හැකි අතර, වෙළෙන්දන්ට ගබඩා විකුණුම් දත්ත වැඩි කළ හැකිය. මෙය අන්තර්ජාල බ්ලොක්චේන් ආකෘතියේ නවතම ලාභ ආකෘතියයි!',
    'bz8': '2.ebay Review RoBoT ක්‍රියා කරන්නේ කෙසේද?',
    'bz9': 'ebay Review RoBoT හි දෛනික ප්‍රතිපෝෂණ සංදර්ශනය හරහා, ebay Review RoBoT හි වැඩිදියුණු කළ යුතු නිෂ්පාදන අලෙවි කෙරේ. පරිශීලකයන්ට ඇණවුම මත පහසුවෙන් ක්ලික් කිරීමට අවශ්‍ය වන අතර, පද්ධතිය ස්වයංක්‍රීයව ඇණවුම් දායකත්වයක් ජනනය කරයි. පරිශීලකයන් බ්ලොක්චේන් USDT හරහා ඇණවුම් මුදල ගෙවන අතර දෛනික කොමිස් ලබා ගනී.',
    'bz10': '3.ගනුදෙනු දෙකක එකම මුදල් ඒකකයේ මිල වෙනස් වන්නේ ඇයි?',
    'bz11': 'මිල වෙනස ඇතිවන්නේ මුදල් ඒකකයේ නිදහස් සංසරණයට බාධා කරන සියලු සාධක නිසාය. මුදල් හුවමාරු වේගය, ජාල තත්වයන්, මුදල් ප්‍රවේශ සීමා කිරීම්, විවිධ කලාපවල පුද්ගලයන්ගේ මුදල් පිළිගැනීම සහ හුවමාරු මධ්‍යස්ථාන මඟින් සපයන වෙළඳ යුගල වර්ග, ගනුදෙනු ආදිය ඇතුළත් වේ. එබැවින්, එකම මුදල් ඒකකයට විවිධ ගනුදෙනු වලදී මිල වෙනස්කම් ඇති විය හැකිය.',
    'bz12': '4.ආයෝජන ලාභය?',
    'bz13': 'ඔබට ලැබෙන භාණ්ඩ මිල වැඩි වන තරමට, ඔබට ලැබෙන ඇණවුම් ලාභය වැඩි වේ. ඒ සමඟම, ebay Review RoBoT අහඹු ලෙස විශාල කොමිස් ඇණවුම් බෙදා හරියි.',
    'bz14': 'සෑම දිනකම, පද්ධතිය ස්වයංක්‍රීයව භාණ්ඩ ඇණවුම් 60ක් ජනනය කර පරිශීලකයන්ට බෙදා හරින අතර, පරිශීලකයන් USDT හරහා එක් එක් ඇණවුමේ ගෙවීම සම්පූර්ණ කර 0.6% කොමිස් ලබා ගනී. විශාල කොමිස් ඇණවුම් අහඹු ලෙස බෙදා හරිනු ලැබේ.',
    'bz15': 'ඇණවුම් 60කට පසු USDT මුදල් ආපසු ගත හැකිය. (ඇණවුම් 60 සම්පූර්ණ නොවන්නේ නම්, පද්ධතිය ස්වයංක්‍රීයව දවසේ ඉතිරි ඇණවුම් ප්‍රමාණය නවත්වනු ඇත)',
    'bz16': 'සෑම ගිණුමකටම බැඳිය හැක්කේ එක් USDT ගිණුමක් පමණි, දෝෂයක් සිදුවුවහොත් කරුණාකර පාරිභෝගික සේවය අමතන්න',
    'bz17': 'දෛනික ඇණවුම් බෙදාහැරීම සම්පූර්ණ කිරීමෙන් පසු, සාමාන්‍යයෙන් මුදල් ආපසු ගත හැකිය. මුදල් ආපසු ගැනීම ආරම්භ කිරීමෙන් පැය 24ක් ඇතුළත ගිණුමට ලැබෙන අතර මුදල් ආපසු ගැනීමේ සීමාවන් නොමැත',
    'bz18': 'මුදල් එකතු කිරීමට පෙර කරුණාකර ඔබගේ මුදල් ආපසු ගැනීමේ ලිපිනය (TRC-20 සඳහා සහය දක්වයි) USDT ලිපිනය බැඳින්න. ඔබට APP හෝ වෙබ් පිටුවට ගොස් මුදල් එකතු කිරීම ක්ලික් කර, ඔබ භාවිතා කරන බ්ලොක්චේන් (TRC-20) තෝරා මුදල් එකතු කළ හැකිය.',
    'bz19': 'සම්බන්ධිත ගිණුම් අතර අන්‍යෝන්‍ය මුදල් එකතු කිරීම හෝ බැංකු හුවමාරු, හුවමාරු මධ්‍යස්ථාන හුවමාරු වැනි ක්‍රියා තහනම්ය. එවැනි හැසිරීම් ද්වේෂසහගත ඇණවුම් ගැනීමක් ලෙස සැලකෙන අතර, එය සොයාගතහොත් ගිණුම අත්හිටුවීමේ දඬුවමට යටත් වේ',
    //මොඩියුල පෙළ
    //පොදු වචන
    'ty1': 'තහවුරු කරන්න',
    'ty2': 'අවලංගු කරන්න',
    'ty3': 'ඉදිරිපත් කරන්න',
    "ty4": "TRC20 ලිපිනය",
    "ty5": "ERC20 ලිපිනය",
    //මුල් පිටුව
    's1': 'සමුච්චිත ආදායම',
    's2': 'සේවාව',
    's3': 'අප ගැන',
    's4': 'උදව්',
    's5': 'හවුල්කරුවන්',
    's6': 'මගේ සේවාව',
    //ඇණවුම්
    'd1': 'නිම නොකළ',
    'd2': 'සම්පූර්ණ කළ',
    'd3': 'දත්ත නැත',
    'd4': 'ඇණවුම් අංකය',
    'd5': 'ගනුදෙනු වේලාව',
    'd6': 'මුදල',
    'd7': 'වත්මන් කාර්ය සංඛ්‍යාව',
    'd8': 'අපේක්ෂිත ආදායම',
    'd9': 'තවත් අවශ්‍යයි',
    'd10': 'ශ්‍රේණිගත කිරීම',
    //ගනුදෙනු
    'j1': 'ගිණුම් ශේෂය',
    'j2': 'ගනුදෙනු හැඳින්වීම',
    'j3': 'ebay Review RoBoT දිනපතා ebay Review RoBoT හි ප්‍රතිපෝෂණ භාවිතා කර ebay Review RoBoT අලෙවි කරන වැඩිදියුණු කළ යුතු නිෂ්පාදන පෙන්වයි. පරිශීලකයන්ට ඇණවුම මත ක්ලික් කිරීමට අවශ්‍ය වන අතර, පද්ධතිය ස්වයංක්‍රීයව ඇණවුම් අත්සන ජනනය කරයි. පරිශීලකයන් USDT බ්ලොක්චේන් හරහා ඇණවුම් මුදල ගෙවන අතර සෑම අවස්ථාවකදීම 0.6% ට වැඩි කොමිස් ලබා ගනී. පද්ධතිය අහඹු ලෙස විශාල ත්‍යාග ඇණවුම් බෙදා හරියි.',
    'j4': 'ගැලපීම ආරම්භ කරන්න',
    'j5': 'අද ආදායම',
    'j6': 'සම්පූර්ණ කළ සංඛ්‍යාව',
    'j7': 'මුළු කාර්ය සංඛ්‍යාව',
    //කණ්ඩායම
    'td1': 'ශේෂය',
    'td2': 'කොමිස්',
    'td3': 'ලබා ගන්න',
    'td4': 'මුළු සංඛ්‍යාව',
    'td5': 'පරිශීලක',
    'td6': 'දායකත්වය',
    'td7': 'ප්‍රමාණය',
    'td8': 'තත්ත්වය',
    //පුද්ගලික මධ්‍යස්ථානය
    'g1': 'මුදල් ආපසු ගන්න',
    'g2': 'මුදල් එකතු කරන්න',
    'g3': 'මිතුරන්ට ආරාධනා කරන්න',
    'g4': 'දැන් ආරාධනා කරන්න',
    'g5': 'මිතුරා ලියාපදිංචි වීමෙන් පසු උපයන සෑම ලාභයකින්ම, ඔබට අනුරූප අනුපාතයේ කොමිස් ලැබෙනු ඇත',
    'g6': 'පුද්ගලික තොරතුරු',
    'g7': 'අරමුදල් විස්තර',
    'g8': 'මුදල් එකතු කිරීමේ වාර්තා',
    'g9': 'මුදල් ආපසු ගැනීමේ වාර්තා',
    'g10': 'භාෂාව',
    'g11': 'ඉවත් වෙන්න',
    'g12': 'ඔබට විශ්වාසද ඉවත් වීමට අවශ්‍ය බව?',
    //පරිශීලක තොරතුරු
    'yh1': 'පරිශීලක තොරතුරු',
    'yh2': 'වෙනස් කරන්න',
    'yh3': 'සැකසුම්',
    'yh4': 'දුරකථනය',
    'yh6': 'මුල් මුරපදය',
    'yh7': 'නව මුරපදය',
    //විස්තර
    'mx1': 'කොමිස් ලබා ගැනීම',
    'mx2': 'ආදායම',
    'mx3': 'මුදල් ආපසු ගැනීම ප්‍රතික්ෂේප කළා',
    'mx4': 'වේලාව',
    'mx5': 'මුදල් එකතු කිරීම සාර්ථකයි',
    'mx6': 'ප්‍රතික්ෂේප කළා',
    'mx7': 'බලාපොරොත්තු වේ',
    'mx8': 'මුදල් ආපසු ගැනීමේ ලිපිනය',
    'mx9': 'පවතින ශේෂය',
    'mx10': 'සැබෑ ලැබීම',
    'mx11': 'කරුණාකර මුදල් ආපසු ගැනීමේ ප්‍රමාණය ඇතුළත් කරන්න',
    //මුදල් එකතු කිරීම
    'cz1': 'තැන්පතු ලිපිනය ERC20 සඳහා පමණක් සහය දක්වයි, අවම තැන්පතු මුදල 20USDT වේ',
    'cz2': 'පිටපත් කරන්න',
    'cz3': 'නීත්‍යානුකූල මුදල් තේරීම',
    'cz4': 'ගෙවීම',
    'cz5': 'තැන්පතු ලිපිනය TRC20-USDT සඳහා පමණක් සහය දක්වයි, අවම තැන්පතු මුදල 20USDT වේ',
    'cz6': 'තැන්පතු ලිපිනය ERC20 සඳහා පමණක් සහය දක්වයි, අවම තැන්පතු මුදල 20USDT වේ',
    'cz1': 'තැන්පතු ලිපිනය ERC20 සඳහා පමණක් සහය දක්වයි, අවම තැන්පතු මුදල 20USDT වේ',
    'cz1': 'තැන්පතු ලිපිනය ERC20 සඳහා පමණක් සහය දක්වයි, අවම තැන්පතු මුදල 20USDT වේ',
    "cz10": "තැන්පතු ලිපිනය BTC සඳහා පමණක් සහය දක්වයි",
    //කලාපය
    'qy1': 'ප්‍රාදේශීය කේතය',
    //ආරාධනා
    'yq1': 'මිතුරන්ට ආරාධනා කරන්න',
    'yq2': 'ආරාධනා කේතය',
    'yq3': 'මිතුරන්ට ආරාධනා කරන්න, විශාල ආදායමක් භුක්ති විඳින්න ',
    'yq4': ' ආරාධනා කිරීමට යන්න',
    // 7.23 එකතු කළා
    "new1": "ගෙවීම් ක්‍රමය",
    // නවතම ගෙවීම් නාලිකා තේරීම
    "zf1": "මුදල් එකතු කිරීමේ ක්‍රමය",
    "zf2": "කරුණාකර මුදල් එකතු කිරීමේ ක්‍රමය තෝරන්න",
    "zf3": "ගනුදෙනු මුදල් ඒකකය",
    "zf4": "ගනුදෙනු ජාලය",
    "zf5": "ගනුදෙනුවට යන්න",
    "zf6": "පිටපත් කිරීම සාර්ථකයි",
    "zf7": "ගනුදෙනු මුදල් ඒකකය",
    "zf8": "කරුණාකර භාවිතා කරන්න",
    "zf9": "මුදල් එකතු කිරීම සම්පූර්ණ කිරීමට පහත ලිපිනයට මාරු කරන්න.",
    "zf10": "ගනුදෙනු මුදල් වර්ගය",
    "zf11": "පිටපත් කරන්න",
    "zf12": "කරුණාකර ලිපිනය හොඳින් පරීක්ෂා කරන්න, වැරදි ලිපිනයකට මාරු කළහොත් ආපසු ලබා ගත නොහැක",
    "zf13": "ගිණුමට ලැබෙන වේලාව",
    "zf14": "ආසන්න වශයෙන් විනාඩි 1~5",
    "zf15": "අවම මුදල් එකතු කිරීමේ ප්‍රමාණය",
    //පාරිභෝගික සේවය
    "kf1": "සබැඳි පාරිභෝගික සේවය",
    "kf2": "මානව පාරිභෝගික සේවා මුදල් ආපසු ගැනීම",
    "kf3": "මානව පාරිභෝගික සේවා මුදල් ආපසු ගැනීම සඳහා ඔබට මෙතැන ක්ලික් කළ හැකිය",
    "kf4": "මානව පාරිභෝගික සේවා මුදල් එකතු කිරීම",
    "kf5": "මානව පාරිභෝගික සේවා මුදල් එකතු කිරීම සඳහා ඔබට මෙතැන ක්ලික් කළ හැකිය",
    //ගෙවීම් විකල්ප උත්පතන
    "zf16": "බැංකු කාඩ් ගනුදෙනු සඳහා කරුණාකර පාරිභෝගික සේවය අමතන්න",
    "zf17": "පාරිභෝගික සේවය අමතන්න",
    "a1": "ගබඩා අලෙවිකරණ මධ්‍යස්ථානය",
    "a2": "ebay Review RoBoT ගබඩා අලෙවිකරණ මධ්‍යස්ථානය යනු වෙළෙන්දන්ට කෙටි කාලයක් තුළ නිෂ්පාදන අලෙවිය සහ හොඳ සමාලෝචන අනුපාතය වේගයෙන් වැඩි කිරීමට උපකාර වන නව කොටසකි. එමඟින් නිෂ්පාදන බර වැඩි කර නිරාවරණය තවදුරටත් වැඩි කරයි. පරිශීලකයන් විවිධ කාර්යයන් සම්පූර්ණ කිරීමෙන් වෙළෙන්දන්ට උපකාර කරන අතර අනුරූප ත්‍යාග ලබා ගනී. එමඟින් දෙපාර්ශ්වයටම ජයග්‍රහණයක් අත්කර ගනී.",
    "a3": "දැනට, පද්ධතියට පරිශීලකයන් මිලියන 30ක් සහ වෙළෙන්දන් මිලියන 5ක් සිටින අතර, දිනපතා වේදිකාවේ ප්‍රවර්ධනය කරන නිෂ්පාදන සංඛ්‍යාව මිලියන 70කි. සමහර වෙළෙන්දන් අලෙවිකරණ මධ්‍යස්ථාන පද්ධතියට ප්‍රවේශ වීමෙන් ගබඩා අලෙවිය 60% කින් වැඩි කර ඇත. අලෙවිකරණ මධ්‍යස්ථාන පද්ධතියේ වේදිකා පරිශීලකයන්ට ඇණවුම මත ක්ලික් කිරීමට අවශ්‍ය වන අතර, අලෙවිකරණ මධ්‍යස්ථාන පද්ධතිය ස්වයංක්‍රීයව ඇණවුම් අත්සන ජනනය කරයි. පරිශීලකයන් පෙරගෙවුම් ඇණවුම් මුදල ගෙවා අතථ්‍ය ගනුදෙනුව සම්පූර්ණ කිරීමෙන් පසු අරමුදල් වහාම පරිශීලක ගිණුමට ආපසු ලැබේ. සෑම අවස්ථාවකදීම 0.6% ට වැඩි අමතර කොමිස් ලබා ගත හැකි අතර, පද්ධතිය පරිශීලකයන්ගේ කොමිස් වැඩි කිරීමට අහඹු ලෙස විශාල ත්‍යාග ඇණවුම් ද බෙදා හරියි.",
    "a4": "ebay Review RoBoT පරිශීලකයන්ගේ සහ වෙළෙන්දන්ගේ අවශ්‍යතා සඳහා විශාල වැදගත්කමක් ලබා දෙන අතර අලෙවිකරණ මධ්‍යස්ථාන පද්ධතිය අඛණ්ඩව ප්‍රශස්ත කිරීම සහ වැඩිදියුණු කිරීම සිදු කරයි."
}
